import { render, staticRenderFns } from "./Node.vue?vue&type=template&id=031501c4&scoped=true&"
import script from "./Node.vue?vue&type=script&lang=js&"
export * from "./Node.vue?vue&type=script&lang=js&"
import style0 from "./Node.vue?vue&type=style&index=0&id=031501c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031501c4",
  null
  
)

export default component.exports